import "../styles/catalog.scss"
import '../styles/new-pages.scss'
import '../styles/vis.scss'
import $ from "jquery"
import Cookies from "js-cookie"
import "../styles/catalog.scss"
import './common/twinspark'
import './common/popup-banner'
import './common/header'
import './common/common'
import './common/scroll-top'
import * as forged from "./forged"
// import "hint.css"
import * as forms from './forms'
import { parseInt } from "lodash"

window.ga4SendSelectItemEvent = function ga4SendSelectItemEvent(productId) {
  if (__ga_ecommerce_items && productId) {
    let item = __ga_ecommerce_items.find(x => x.item_id == productId)
    if (item) {
      dataLayer.push({ ecommerce: null })
      dataLayer.push({
        event: "select_item",
        ecommerce: {
          items: [
            item
          ]
        }
      })
    }
  }
}

window.addEventListener("pageshow", function(event) {
  const historyTraversal = event.persisted || (typeof window.performance != "undefined" && window.performance.navigation.type === 2);
  const needToReload = location.pathname.startsWith("/diski/") || location.pathname.startsWith("/shiny/");
  if (historyTraversal && needToReload) {
    window.location.reload();
  }
});

window.addEventListener("load", () => {

  const shareButtonList = document.querySelectorAll(".share-button")
  if (shareButtonList) {
    shareButtonList.forEach(el => {
      el.addEventListener("click", e => {
        e.preventDefault()
        document.documentElement.classList.add("_hidden")
        document.getElementById("modal-share").classList.add("_visible")
      })
    })
  }

  const hideSiteLayout = () => {
    document.getElementById("site-layout").classList.add("d-none")
  }

  const showSiteLayout = () => {
    document.getElementById("site-layout").classList.remove("d-none")
  }

  document.getElementById("site-layout").onclick = e => {
    e.preventDefault()

    hideSiteLayout()
    document.documentElement.classList.remove("_hidden")

    const basket = document.getElementById("component_basket")
    if (basket) {
      basket.classList.remove("_visible")
    }

    const catalog = document.getElementById("component_catalog-filter")
    if (catalog) {
      catalog.classList.remove("_visible")
    }
  }

  const openSideFilter = function() {
    showSiteLayout();
    document.getElementById("component_catalog-filter").classList.add("_visible")
    document.documentElement.classList.add("_hidden")
  }

  const closeSideFilter = function() {
    hideSiteLayout();
    document.getElementById("component_catalog-filter").classList.remove("_visible")
    document.documentElement.classList.remove("_hidden")
  }

  let closeIcon = document.querySelector("#component_catalog-filter .title .close-icon")
  if (closeIcon) {
    closeIcon.onclick = e => {
      e.preventDefault()
      closeSideFilter()
    }
  }

  const tabHeaderList = document.querySelectorAll(".tabs-header .tab")
  const tabContentList = document.querySelectorAll(".tabs-content")

  if (tabHeaderList) {
    tabHeaderList.forEach((el, index) => {
      el.onclick = e => {
        e.preventDefault()

        tabHeaderList.forEach(el => el.classList.remove("_active"))

        el.classList.add("_active")

        tabContentList.forEach(el => el.classList.remove("_visible"))

        tabContentList[index].classList.add("_visible")
      }
    })
  }

  const catalogSizeList = document.querySelectorAll(
    ".page_catalog .filter-wrap .size-list .size"
  )
  if (catalogSizeList.length) {
    catalogSizeList.forEach(el => {
      el.onclick = e => {
        e.preventDefault()

        catalogSizeList.forEach(el => el.classList.remove("_active"))

        e.target.classList.add("_active")
      }
    })
  }

  window.setCatalogViewType = e => {
    if (e) e.preventDefault()
    let catalogViewType = document.querySelectorAll(
      ".page_catalog .filter-wrap .view-type-item"
    )
    catalogViewType.forEach(el => el.classList.remove("_active"))

    e.currentTarget.classList.add("_active")

    const type = e.currentTarget.getAttribute("data-type")

    Cookies.set("catalogViewType", type, { expires: 30 })

    const prodList = document.querySelectorAll(".component_product-item")
    const prodWrap = document.getElementById("catalog-prod-wrap")

    if (type === "list") {
      prodWrap.classList.add("_full")
      prodList.forEach(el => el.classList.add("_full"))
    } else if (type === "grid") {
      prodWrap.classList.remove("_full")
      prodList.forEach(el => el.classList.remove("_full"))
    }
  }

  const catalogViewType = document.querySelectorAll(
    ".page_catalog .filter-wrap .view-type-item"
  )
  if (catalogViewType.length) {
    catalogViewType.forEach((el) => {
      el.onclick = window.setCatalogViewType
    })
  }

  window.twinspark.func({
    openSideFilter: function(o) {
      openSideFilter()
    },
    applyFastSeason: function(o) {
      const form = document.querySelector(".catalog-filter-form")
      form.querySelectorAll("[name=seasons]").forEach(el => el.checked = false)
      if (o.el.value == "letnie") {
        form.querySelector("[name=seasons][value=letnie]").checked = true
      } else if (o.el.value) {
        form.querySelector("[name=seasons][value=zimnie]").checked = true
        form.querySelectorAll("[name=spikes]").forEach(el => el.checked = false)
        form.querySelector(`[name=spikes][value=${o.el.value}]`).checked = true
      }
      twinspark.trigger(form, "submit")
    },
    applyFastFilter: function(o) {
      var el = document.querySelector('.catalog-filter-form [name=' + o.el.name + ']')
      if (el.type == 'checkbox') {
        el.checked = o.el.checked;
      } else {
        el.value = o.el.value
      }
      twinspark.trigger(el.closest('form'), 'submit');
    },
    applySort: function(o) {
      const url = new URL(window.location)
      if (o.el.value) {
        url.searchParams.set("sorting", o.el.value)
      } else {
        url.searchParams.delete("sorting")
      }
      window.location = url
    },
    setCatalogViewType: function(o) {
      window.setCatalogViewType(o.event)
    },
    closeSideFilter: function(o) {
      closeSideFilter()
    },
  });
})

// window.addEventListener("load", function() {
//   window.initNoUiSlider = async (noUiItems) => {
//     let noUiSlider = await import(/* webpackChunkName: "nouislider" */"nouislider")
//     let wNumb = await import(/* webpackChunkName: "wnumb" */"wnumb")
//     wNumb = wNumb.default
//     noUiItems.forEach(el => {
//       if (el.noUiSlider) {
//         el.noUiSlider.destroy()
//       }

//       if (el.classList.contains('noUi-target')) return

//       const startVal = el.getAttribute("data-start-value")
//       const endVal = el.getAttribute("data-end-value")
//       const minVal = el.getAttribute("data-min-value")
//       const maxVal = el.getAttribute("data-max-value")
//       const decimals = el.getAttribute("data-decimals")

//       let numFormat = wNumb({ decimals: parseInt(decimals) || 0 })

//       const name = el.getAttribute("data-value-name")
//       let left = document.getElementById(`${name}_gte`)
//       let right = document.getElementById(`${name}_lte`)

//       noUiSlider.create(el, {
//         start: [+startVal, +endVal],
//         connect: true,
//         step: 0.5,
//         range: {
//           min: +minVal,
//           max: +maxVal,
//         },
//       })

//       let startValStr = decimals ? numFormat.to(+startVal) : Math.round(+startVal) + ""
//       let endValStr = decimals ? numFormat.to(+endVal) : Math.round(+endVal) + ""
//       const from = el.parentNode.querySelector(".from .value")
//       const to = el.parentNode.querySelector(".to .value")
//       const update_left = v => {
//         from.value = decimals ? numFormat.to(+v) : Math.round(+v) + ""
//         if (from.value != startValStr && left.value != from.value) {
//           left.value = from.value
//         }
//       }
//       const update_right = v => {
//         to.value = decimals ? numFormat.to(+v) : Math.round(+v) + ""
//         if (to.value != endValStr && right.value != to.value) {
//           right.value = to.value
//         }
//       }
//       const fireChange = () => {
//         var event = new Event('changed');
//         left.dispatchEvent(event);
//         right.dispatchEvent(event);
//       }

//       from.addEventListener("change", () => {
//         update_left(from.value)
//         fireChange();
//       })

//       to.addEventListener("change", () => {
//         update_right(to.value)
//         fireChange();
//       })

//       el.noUiSlider.on("update", values => {
//         update_left(values[0])
//         update_right(values[1])
//       })

//       el.noUiSlider.on("change", (a, b) => {
//         fireChange();
//       })
//     })
//   }

//   const noUiItems = document.querySelectorAll(".nouislider")
//   if (noUiItems.length) {
//     initNoUiSlider(noUiItems)
//   }
// })
